import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { DigitalClock } from '@mui/x-date-pickers/DigitalClock';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Popover from '@mui/material/Popover';
import { DateTimeField } from '@mui/x-date-pickers';
import { Bs4PopoverModal } from './Bs4ModalTopCenter';
import * as Bs4Utils from './Bs4Utils'
import Bs4MainDispatch from '../Bs4MainDispatch'
import {   
  isValid,
  format,
  addSeconds, startOfDay,
} from "date-fns";


const ViewBs4DateTimeDialog = (props) => {  
  const inputRef = React.useRef(null);
  const [minTime, maxTime] = React.useMemo(() => {    
    const minTime = Bs4Utils.isNullOrNaN(props.minTime) ? null : addSeconds(startOfDay(new Date()), props.minTime);
    const maxTime = Bs4Utils.isNullOrNaN(props.maxTime) ? null : addSeconds(startOfDay(new Date()), props.maxTime);
    return [minTime, maxTime];
  }, [props.minTime, props.maxTime]);

  const handleClose = (event) => {
    props.onClose(event);
  }

  const handleChangeField = (newValue) => {    
    // console.log('...ViewBs4DateTime...Change.Field..', Bs4Utils.toDateTime(newValue), newValue);
    props.onChange(newValue)
  }

  const handleChangeCalendar = (newValue, selectionState, selectedView) => {
    //console.log('...ViewBs4DateTime...Change.Calendar..', Bs4Utils.toDate(newValue), selectionState, selectedView);
    // if (selectionState !== SELECTION_STATE_OK) return;
    props.onChange(newValue)
  }

  const handleChangeClock = (newValue, selectionState, selectedView) => {
    // console.log('...ViewBs4DateTime...Change.Clock..', Bs4Utils.toDate(newValue), selectionState, selectedView);
    // if (selectionState !== SELECTION_STATE_OK) return;
    props.onChange(newValue)
    handleClose(null);
  }

  const handleChangeNaw = (event) => {      
    props.onChange(new Date())
    handleClose(event);
  }

  const handleClear = (event) => {
    props.onChange(null)
    handleClose(event);
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') handleClose(event);
    if (props.onKeyDown) props.onKeyDown(event);
  }
  
  const disableUnderline = (props.readOnly && !(props.variant && props.variant === 'standard')) ? {disableUnderline: true} : {};

  // /* default */
  // .MuiInput-underline:before {
  //   border-bottom: 2px solid green;
  // }
  // /* hover (double-ampersand needed for specificity reasons. */
  // && .MuiInput-underline:hover:before {
  //   border-bottom: 2px solid lightblue;
  // }
  // /* focused */
  // .MuiInput-underline:after {
  //   border-bottom: 2px solid red;
  // }

  const [xx, xxXX] = Bs4MainDispatch.useBs4Locale();

  // console.log('...ViewBs4DateTimeDialog...', props);

  return (
    <Stack direction="column" spacing={0} sx={{justifyContent: "flex-start", alignItems: "flex-start", overflow: 'auto'}}>
      <Box sx={{width: '100%', paddingX: 1}}>
      <DateTimeField
        inputRef={inputRef}
        autoFocus
        readOnly={Boolean(props.readOnly)}
        label={props.label}  
        value={props.value || null}
        fullWidth={props.fullWidth}
        helperText={props.error?.helperText}
        error={props.error?.error}
        // referenceDate={new Date()}
        // clearable
        ampm={props.ampm || false}
        onChange={handleChangeField}        
        format="yyyy-MM-dd HH:mm"        
        slotProps={{
          inputLabel: props.hideLabel ? {sx:{display:'none'}} : null,
          htmlInput: {readOnly: props.readOnly},
          input: {
            // ...disableUnderline,
          }, 
        }}
        onKeyDown={handleKeyDown}        
      />
      </Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1} sx={{p: 1}}>
        <DateCalendar 
          value={props.value}
          views={['year', 'month', 'day']}
          onChange={handleChangeCalendar}
          sx={{
            width: 'auto',
          }}   
        />
        <DigitalClock
          disabled={props.disabled}
          //ampm={props.ampm}
          value={props.value}          
          timeStep={props.timeStep || 5}
          // disableIgnoringDatePartForTimeValidation
          onChange={handleChangeClock}    
          skipDisabled
          minTime={minTime}
          maxTime={maxTime}
          sx={{
            width: 'auto',
            maxHeight: 300,
          }}               
        />
      </Stack>
      <Stack direction="row" justifyContent='space-between' alignItems="center" spacing={1} sx={{p: 1}}>
        <Stack direction="row" justifyContent='flex-end' alignItems="center" spacing={1} sx={{p: 1}}>
          <Button onClick={handleClear}>{xxXX.components.MuiLocalizationProvider.defaultProps.localeText.clearButtonLabel}</Button>
          <Button onClick={handleChangeNaw}>{xxXX.components.MuiLocalizationProvider.defaultProps.localeText.todayButtonLabel}</Button>            
        </Stack>
        <Button onClick={handleClose}>{'Ok'}</Button>
      </Stack>
    </Stack>
  );
};

export const ViewBs4DateTime = React.forwardRef((props, inputRef) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const ref = React.useRef(null);
  
  const handleClose = (event) => {
    setAnchorEl(null);
    if (props.onClose) props.onClose();
  }  

  const handleOpen = (target) => {
    if (props.readOnly) return;
    document.activeElement?.blur();
    setAnchorEl(ref.current);
    if (props.onOpen) props.onOpen();
  };

  const handleFocus = (event) => {
    handleOpen(event.target);
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') handleClose(event);
  }  

  const getDataTimeText = (value) => {    
    if (!isValid(value)) return  '';
    return format(value, 'yyyy-MM-dd HH:mm')
  }  

  const handleClickAdornment = (event) => {
    handleOpen(inputRef.current);
  }


  // console.log('...ViewBs4DateTime...', inputRef, props);

  return (
    <React.Fragment>
      <TextField
        ref={ref}
        focused={false}
        inputRef={inputRef}
        fullWidth={props.fullWidth}
        label={props.label}
        value={getDataTimeText(props.value)}
        error={Boolean(props.error?.error)}
        helperText={props.error?.helperText}
        slotProps={{
          inputLabel: props.hideLabel ? {sx:{display:'none'}} : null,
          htmlInput: {readOnly: props.readOnly},
          input: {
            disableUnderline: props.readOnly,
            endAdornment:(
              <InputAdornment position="end">
                <IconButton 
                  edge='end' 
                  onClick={handleClickAdornment}
                  disabled={props.readOnly}
                >                  
                  <i className="fa-regular fa-calendar-day"></i>
                </IconButton>
              </InputAdornment>
            )
          },
        }}
        onFocus={handleFocus}
      />
      <Bs4PopoverModal 
        anchorEl={anchorEl}
        open={Boolean(anchorEl)} 
        onClose={handleClose} 
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
          vertical: 8, 
          horizontal: 8,
        }}
        onKeyDown={handleKeyDown}
        sx={{
          overflow: 'hidden', 
        }}
        slotProps={{root: {
          'aria-hidden': false,
        }}}
      >
        <ViewBs4DateTimeDialog          
          {...props}
          onClose={handleClose}
          onOpen={null}
        />
      </Bs4PopoverModal>
    </React.Fragment>
  )
});

export default ViewBs4DateTime;
